<div class="map-algo-space-container">
    <div class="dialog-header padding flex-space-between flex-centered-container-vr">
        <div class="font-14 font-bold">{{ dialogTitle }}</div>
        <button type="button" class="close-button icon-button-hover flex-centered-container cursor-pointer border-radius-full" aria-label="Close" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body padding">
        <div *ngIf="isReadOnly" class="readonly-banner display-flex gap-8-px flex-start border-radius-8 pad-12 margin-8-bottom dynamic-font-12"
            [matTooltip]="frozenTooltip">
            <mat-icon class="readonly-banner-icon flex-shrink">lock</mat-icon>
            <span>{{ frozenTooltip }}</span>
        </div>

        <div class="field-label font-10 placeholder-text margin-4-bottom">Broker account</div>
        <div class="broker-account-field light-background border-field flex-centered-container-vr margin-8-bottom pad-8-hr border-radius-8">
            <img [src]="brokerImageLink" alt="broker-logo" class="img-16-sq margin-4-right">
            <span class="dynamic-font-12">{{ brokerDisplayName }}</span>
        </div>

        <div class="flex-space-between flex-centered-container-vr section-heading margin-4-top margin-8-bottom">
            <span class="font-10 placeholder-text">Choose Algo Spaces</span>
            <div class="flex-centered-container-vr section-heading-actions gap-8-px flex-shrink">
                <button type="button" class="refresh-button icon-button-hover flex-centered-container cursor-pointer border-radius-full"
                    aria-label="Refresh algo spaces"
                    [disabled]="isLoading || isRefreshing || isSubmitting"
                    (click)="refreshAlgoSpaces()">
                    <mat-icon [class.spinning]="isRefreshing">refresh</mat-icon>
                </button>
                <span class="selected-count-badge extra-spaces-badge font-10 font-bold no-wrap pad-4-hr border-radius-12">{{ selectedSpaceIds.size }} selected</span>
            </div>
        </div>

        <ng-container *ngIf="!isLoading; else loading">
            <div *ngIf="algoSpaces.length; else emptyState" class="algo-space-list pad-4">
                <div *ngFor="let space of algoSpaces; trackBy: trackBySpaceId" class="algo-space-option display-flex gap-8-px pad-12"
                    [class.cursor-pointer]="!isSpaceInteractionDisabled(space)"
                    [class.selected]="selectedSpaceIds.has(space.id)"
                    [class.disabled]="isSpaceInteractionDisabled(space)"
                    [matTooltip]="getSpaceDisabledTooltip(space)"
                    [matTooltipDisabled]="!getSpaceDisabledTooltip(space)"
                    (click)="onSpaceOptionClick(space)">
                    <mat-checkbox class="algo-space-checkbox flex-shrink" disableRipple
                        [checked]="selectedSpaceIds.has(space.id)"
                        [disabled]="isSpaceInteractionDisabled(space)"
                        (change)="toggleSpace(space, $event.checked)"
                        (click)="$event.stopPropagation()">
                    </mat-checkbox>
                    <div class="algo-space-details flex-1 min-width-0">
                        <div class="flex-space-between flex-centered-container-vr gap-8-px">
                            <div class="algo-space-primary min-width-0 flex-1">
                                <div class="dynamic-font-12 font-bold flex-centered-container-vr gap-4-px min-width-0">
                                    <mat-icon class="algo-space-icon flex-shrink">dns</mat-icon>
                                    <span class="algo-space-ip overflow-ellipsis">{{ space.reserved_ip }}</span>
                                    <mat-icon class="algo-space-copy-icon cursor-pointer flex-shrink"
                                        aria-label="Copy IP"
                                        (click)="copyReservedIp($event, space.reserved_ip)">content_copy</mat-icon>
                                </div>
                                <div class="flex-centered-container-vr margin-4-top algo-space-subrow gap-4-px min-width-0">
                                    <mat-icon class="space-name-icon algo-space-icon flex-shrink">view_in_ar</mat-icon>
                                    <span class="font-10 placeholder-text algo-space-name overflow-ellipsis">{{ space.space_name }}</span>
                                </div>
                            </div>
                            <span *ngIf="getOtherMappedBrokerCount(space) as otherCount"
                                class="mapped-other-brokers fg-accent font-10 flex-centered-container-vr gap-4-px flex-shrink no-wrap">
                                <mat-icon class="mapped-other-brokers-icon flex-shrink fg-accent">link</mat-icon>
                                {{ otherCount }} other{{ otherCount > 1 ? 's' : '' }}
                            </span>
                            <span class="status-badge font-10 flex-centered-container-vr gap-4-px border-radius-12 font-bold no-wrap flex-shrink"
                                [class.status-active]="!space.status || space.status === 'active'"
                                [class.text-new-green]="!space.status || space.status === 'active'"
                                [class.placeholder-text]="space.status === 'expired' || space.status === 'provisioning'"
                                [class.badge-card]="space.status === 'expired' || space.status === 'provisioning'">
                                <span *ngIf="!space.status || space.status === 'active'" class="status-dot bg-text-green flex-shrink"></span>
                                {{ (space.status || 'active') | titlecase }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #emptyState>
                <div class="font-10 placeholder-text empty-state text-center">No algo spaces available.</div>
            </ng-template>

            <p class="footer-note font-10 placeholder-text margin-8-top no-margin-bottom">
                {{ footerNote }}
                <ng-container *ngIf="!isReadOnly">
                    Need another?
                    <button type="button" class="buy-algo-space-link font-10 text-accent cursor-pointer"
                        (click)="redirectToBuyAlgoSpace()">Buy an Algo Space →</button>
                </ng-container>
            </p>
        </ng-container>
        <ng-template #loading>
            <div class="font-10 placeholder-text loading-state text-center">Loading algo spaces...</div>
        </ng-template>
    </div>

    <div class="dialog-footer strategy-form-fixed-footer padding flex-space-end gap-12-px flex-centered-container-vr">
        <button mat-stroked-button type="button" class="cancel-button border-field bg-white dynamic-font-12" (click)="closeDialog()">
            {{ isReadOnly ? 'Close' : 'Cancel' }}
        </button>
        <button *ngIf="!isReadOnly" mat-flat-button color="accent" type="button"
            class="done-button dynamic-font-12 flex-centered-container new-theme-gradient-bg fg-white"
            [disabled]="isConfirmDisabled" (click)="confirmSelection()">
            {{ isSubmitting ? 'Saving...' : 'Confirm' }}
        </button>
    </div>
</div>
